import {Component, Input} from "@angular/core";
import {Router} from "@angular/router";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-fixed-horizontal-nav-bar-scroll',
  templateUrl: './st-fixed-horizontal-nav-bar-scroll.component.html',
  styleUrls: ['./st-fixed-horizontal-nav-bar-scroll.component.scss'],
  standalone: false
})
export class StFixedHorizontalNavBarScrollComponent {

  @Input()
  idVal: string = 'fixed-horiz-nav-bar-scroll-id'

  @Input()
  elementTags: any = [];

  public scrollToSelected(selectedId :string): void {
    const element = document.getElementById(selectedId);
    // @ts-ignore
    element.scrollIntoView({ behavior: 'smooth' });

    for (const htmlIdObj of this.elementTags) {
      if (htmlIdObj['id'] == selectedId) {
        htmlIdObj['selected'] = true;
      } else {
        htmlIdObj['selected'] = false;
      }
    }
  }
}
